// Ultimate Card Game (UCG) - Per-Unit Spawn & Death Sound Overrides
//
// Generisches Spawn-/Sterbegeräusch pro Rasse lebt in js/engine/audio.js's
// BARK_FILES (playBark(race, 'spawn'|'death')) - das greift automatisch für
// jede Einheit, die hier NICHT eingetragen ist. Eine Einheit in einem der
// beiden Registers unten bekommt STATTDESSEN ihr eigenes Geräusch; die
// generische Rassen-Bark wird für sie unterdrückt (nie beide gleichzeitig).
//
// Vor dem Ergänzen einer Einheit: docs/CARD_AUTHORING_GUIDE.md lesen. Die
// eigentliche Sound-Methode/Datei bleibt dort verdrahtet, wo sie bereits im
// Code lebt (js/engine/audio.js, js/engine/unit.js) - diese Datei ist nur
// das Nachschlage-Register, welche Einheiten NICHT das generische
// Rassen-Geräusch bekommen sollen. tools/sound-catalog/generate-catalog.mjs
// liest aus diesem Modul, damit der Sound-Katalog Spawn/Tod pro Einheit
// (Override oder generischer Rassen-Fallback) korrekt auflistet.

// Spawn: eigenes Geräusch feuert bereits an anderer Stelle im Code -
// - TheSalvageCompany: playSalvageHorn() beim Ausspielen (js/ui/hud.js x2,
//   js/engine/cardSystem.js)
// - WheelieBomber: playWheelieEngine() beim Losfahren, 1. Simulationsframe
//   (js/engine/unit.js's driveAudioPending)
// - A9Piranha: startA9PiranhaMotorLoop(), durchgehend ab 1. Simulationsframe
//   (js/engine/unit.js's motorLoopPending)
export const UNITS_WITH_CUSTOM_SPAWN_SOUND = new Set([
  'TheSalvageCompany',
  'WheelieBomber',
  'A9Piranha',
]);

// Tod: aktuell keine Einheit mit eigenem Sterbegeräusch - jede Einheit
// nutzt die generische Rassen-Bark + Maschinerie/Infanterie-Klassifizierung
// (js/engine/unit.js's _playDeathSound(), aufgerufen aus die() UND
// takeDamage() - beides eigenständige Sterbe-Pfade, siehe Kommentare dort).
// Neuer Eintrag: { method: '<audio.js-Methodenname>', args: [...führende
// Positionsargumente vor dem {x}-Opts-Objekt, das _playDeathSound() anhängt] }.
export const UNIT_DEATH_SOUNDS = {
  HotHand: { method: 'playHotHandDeath' },
  PinkBeret: { method: 'playPinkBeretDeath' },
  Hacker: { method: 'playHackerDeath' },
  A9Pigeon: { method: 'playA9PigeonDeath' },
};

export function hasCustomSpawnSound(card) {
  if (!card) return false;
  return UNITS_WITH_CUSTOM_SPAWN_SOUND.has(card.unitType) || UNITS_WITH_CUSTOM_SPAWN_SOUND.has(card.name);
}

export function getCustomDeathSound(cardData) {
  if (!cardData) return null;
  return UNIT_DEATH_SOUNDS[cardData.unitType] || UNIT_DEATH_SOUNDS[cardData.name] || null;
}
